import type { Ride } from "../types/ride";
import { getRideSummaryRows } from "../utils/formatRideMetrics";
import type { PreferredUnits } from "../../athlete-profile/types/athleteProfile";

type RideSummaryProps = {
  ride: Ride;
  preferredUnits: PreferredUnits;
  isParsingRide: boolean;
  rideParseError: string | null;
};

export function RideSummary({ ride, preferredUnits, isParsingRide, rideParseError }: RideSummaryProps) {
  return (
    <div className="ride-summary-card panel">
      <div className="ride-summary-header">
        <div>
          <p className="eyebrow">RIDE SUMMARY</p>
          <h2>Latest parsed ride</h2>
        </div>
        <span className={`summary-status ${isParsingRide ? "is-loading" : ""}`}>
          {isParsingRide ? "Parsing..." : rideParseError ? "Unavailable" : "Ready"}
        </span>
      </div>
      <p className="summary-copy">
        {rideParseError
          ? "The selected FIT file could not be decoded."
          : "Validated primary ride metrics. Final analysis opens only after source review."}
      </p>
      <div className="summary-grid">
        {isParsingRide
          ? ["Ride date", "Moving time", "Distance", "Average power"].map(label => (
              <div className="summary-item summary-placeholder" key={label} aria-hidden="true">
                <span>{label}</span>
                <strong />
              </div>
            ))
          : getRideSummaryRows(ride, preferredUnits)
              .filter(([, value]) => value !== "--")
              .map(([label, value]) => (
                <div className="summary-item" key={label}>
                  <span>{label}</span>
                  <strong>{value}</strong>
                </div>
              ))}
      </div>
    </div>
  );
}
